import type { ChatMemoryRecord } from '../../stores/chat/memory-store'

import { storage } from '../storage'

export const chatMemoryRepo = {
  async getRecord(key: string) {
    return await storage.getItemRaw<ChatMemoryRecord>(`local:chat/memory/${key}`)
  },

  async saveRecord(key: string, record: ChatMemoryRecord) {
    await storage.setItemRaw(`local:chat/memory/${key}`, record)
  },
}
